module.exports = __webpack_public_path__ + "static/media/stockhausen_augen_17.a6a47978.jpg";